const httpMethods = {
  Post: 'POST',
  Put: 'PUT',
};

export default httpMethods;
